// extracted by mini-css-extract-plugin
export var emailBlockLink = "_q9-0";